module.exports = __webpack_public_path__ + "img/entbg.7f3bbd6e.jpg";